<template>
    <link-move-item class="link-tag" :class="classes" @click.native="handleClick">
        <div class="link-tag-default" v-if="!renderFunc && !scopedSlotFunc">
            <span class="link-tag-label">{{label}}</span>
            <link-icon icon="link-icon-close" v-if="!!deleteable"/>
        </div>
        <div class="link-tag-render" v-if="!!renderFunc">
            <link-rendering-render-func :render-func="renderFunc" :data="{item:proxy}"/>
        </div>
        <div class="link-tag-render" v-if="!!scopedSlotFunc">
            <link-rendering-scope-slot :scope-slot-func="scopedSlotFunc" :data="{item:proxy}"/>
        </div>
    </link-move-item>
</template>

<script>
    import LinkMoveItem from "../move/link-move-item";
    import LinkIcon from "../icon/link-icon";
    import LinkRenderingRenderFunc from "../render/link-rendering-render-func";
    import LinkRenderingScopeSlot from "../render/link-rendering-scope-slot";

    export const MODAL_TYPES = {
        primary: {icon: 'icon-info-circle-fill', color: '#2D8DF0'},
        info: {icon: 'icon-info-circle', color: '#808695'},
        success: {icon: 'icon-checked-circle-fill', color: '#43B973'},
        warn: {icon: 'icon-alert', color: '#ffb020'},
        error: {icon: 'icon-close-circle-fill', color: '#ED4114'},
    };

    export default {
        name: 'link-tag',
        components: {
            LinkRenderingScopeSlot,
            LinkRenderingRenderFunc,
            LinkIcon,
            LinkMoveItem,
        },
        props: {
            label: {type: String},
            value: {},
            index: {type: Number},
            data: {},
            color: {
                type: String,
                validator(val) {
                    return LinkUtils.oneOf(val, ['primary', 'info', 'success', 'warn', 'error', 'none']);
                },
            },
            deleteable: {type: Boolean, default: true},
            type: {
                type: String,
                default: 'fill',
                validator(val) {
                    return LinkUtils.oneOf(val, ['fill', 'line', 'none']);
                },
            },
            shape: {
                type: String,
                default: 'none',
                validator(val) {
                    return LinkUtils.oneOf(val, ['fillet', 'round', 'none']);
                },
            },
            dashed: {
                type: Boolean,
            },
            renderFunc: {type: Function},
            scopedSlotFunc: {type: Function},
        },
        data() {
            let _this = this;
            return {
                proxy: {
                    get label() {
                        return _this.label;
                    },
                    get value() {
                        return _this.value;
                    },
                    get index() {
                        return _this.index;
                    },
                    get color() {
                        return _this.color;
                    },
                    get deleteable() {
                        return _this.deleteable;
                    },
                    get type() {
                        return _this.type;
                    },
                    get shape() {
                        return _this.shape;
                    },
                    get dashed() {
                        return _this.dashed;
                    },
                    get data() {
                        return _this.data
                    },
                }
            };
        },
        computed: {
            classes() {
                return [
                    `link-tag-${!!this.dashed ? 'line' : this.type}`,
                    `link-tag-color-${this.targetColor}`,
                    `link-tag-shape-${this.shape}`,
                    {
                        'link-tag-dashed': !!this.dashed,
                        'link-tag-disabled': !!this.disabled,
                    }
                ];
            },
            targetColor() {
                if (!this.color) {
                    let colors = Object.keys(MODAL_TYPES);
                    return colors[_.random(0, colors.length - 1)];
                } else {
                    return this.color;
                }
            },
        },
        methods: {
            handleClick(e) {
                if (!!this.deleteable) {
                    this.$emit('remove', this.index);
                }
            },
        },
    };
</script>
<style lang="scss">
    .link-tag {
        box-sizing: border-box;
    }
</style>
